<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%">
        <v-flex lg12 pa-5>
          <v-layout mt-3 v-if="incidencia.codigoEstado === '50'">
            <h2 class="primary--text text-uppercase text-center">
              {{localization.datosCierre.title}}
            </h2>
          </v-layout>
          <v-divider v-if="incidencia.codigoEstado === '50' && !rolCliente" class="divider_subtitle"></v-divider>
          <v-row v-if="incidencia.codigoEstado === '50' && !rolCliente" justify="start" align="start">
            <v-col class="pb-0">
              <v-text-field 
                v-model="computadaFechaCierre" id="computadaFechaCierre"
                :label="localization.datosCierre.fechaCierre"
                readonly
              />
            </v-col>
            <v-col cols="6" class="pb-0">
              <v-text-field 
                v-model="lastLogIncidence.observaciones" id="lastLogIncidence.observaciones"
                :label="localization.datosCierre.observaciones"
                readonly
              />
            </v-col>
            <v-col cols="1" class="pb-0">
              <v-row justify="center">
                <v-checkbox
                  v-model="vistoBueno" id="vistoBueno"
                  :label="localization.datosCierre.vistoBueno"
                  disabled
                />
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-img v-if="getCierrePicturesFirma.length != 0" contain :src="'data:image/*;base64,' + getCierrePicturesFirma[(getCierrePicturesFirma.length - 1)].smallPicture" max-height="100"></v-img>
            </v-col>
            <v-col cols="6"><v-text-field 
                v-model="textoConformidad" id="textoConformidad"
                :label="localization.datosCierre.textoConformidad"
                readonly
              /></v-col>
            <v-col cols="12" class="pt-0">
              <v-row>
                <v-col cols="12" class="py-0">
                  <h3 class="primary--text text-uppercase text-start">
                    {{$t('datosIncidencia.datosClienteCierre.titulo')}}
                  </h3>
                </v-col>
                <v-col cols="7" class="py-0">
                  <v-text-field
                    :label="$t('datosIncidencia.datosClienteCierre.nombre')"
                    :value="nombreClienteCierre"
                    readonly
                  />
                </v-col>
                <v-col cols="5" class="py-0">
                  <v-text-field
                    :label="$t('datosIncidencia.datosClienteCierre.nif')"
                    :value="nifClienteCierre"
                    readonly
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-layout mt-3 v-if="!rolCliente">
            <h2 class="primary--text text-uppercase text-center">
              {{localization.costes.title}}
            </h2>
          </v-layout>
          <v-divider v-if="!rolCliente" class="divider_subtitle"></v-divider>
          <v-form v-if="!rolCliente" v-model="valid" id="valid" ref="formCostes">
            <v-col cols="3" class="ml-6">
              <!-- <v-row>
                <v-text-field
                  v-model="incidencia.costeEstimado" id="incidencia.costeEstimado"
                  label="Estimado"
                  :rules="[rules.precioNumber]"
                  append-icon="mdi-currency-eur"
                  @change="updateCambiado(true)"
                />
              </v-row> -->
              <v-row align="center">
                <o-numeric-text-field
                  v-model="incidencia.costeEstimado" id="incidencia.costeEstimado"
                  :label="localization.costes.estimado"
                  suffix="€"
                  :disabled="this.rolProveedor"
                />
              </v-row>
              <!-- <v-row>
                <v-text-field
                  v-model="incidencia.costeAprobado" id="incidencia.costeAprobado"
                  label="Aprobado"
                  :rules="[rules.precioNumber]"
                  append-icon="mdi-currency-eur"
                  @change="updateCambiado(true)"
                />
              </v-row> -->
              <v-row align="center">
                <o-numeric-text-field
                  v-model="incidencia.costeAprobado" id="incidencia.costeAprobado"
                  :label="localization.costes.aprobado"
                  suffix="€"
                  :disabled="this.rolProveedor"
                />
              </v-row>
              <!-- <v-row>
                <v-text-field
                  v-model="incidencia.costeRechazado" id="incidencia.costeRechazado"
                  label="Rechazado"
                  :rules="[rules.precioNumber]"
                  append-icon="mdi-currency-eur"
                  @change="updateCambiado(true)"
                />
              </v-row> -->
              <v-row align="center">
                <o-numeric-text-field
                  v-model="incidencia.costeRechazado" id="incidencia.costeRechazado"
                  :label="localization.costes.rechazado"
                  suffix="€"
                  :disabled="this.rolProveedor"
                />
              </v-row>
              <!-- <v-row>
                <v-text-field
                  v-model="incidencia.costeReal" id="incidencia.costeReal"
                  label="Real"
                  :rules="[rules.precioNumber]"
                  append-icon="mdi-currency-eur"
                  @change="updateCambiado(true)"
                />
              </v-row> -->
              <v-row align="center">
                <o-numeric-text-field
                  v-model="incidencia.costeReal" id="incidencia.costeReal"
                  :label="localization.costes.real"
                  suffix="€"
                  :disabled="this.rolProveedor"
                />
              </v-row>
              <v-row>
                <v-checkbox 
                  v-model="incidencia.facturado" id="incidencia.facturado"
                  :label="localization.costes.facturado"
                  @change="updateCambiado(true)"
                  :disabled="this.rolProveedor"
                />
              </v-row>
            </v-col>
          </v-form>
          <v-layout mt-3>
            <h2 class="primary--text text-uppercase text-center">
              {{localization.historico.title}}
            </h2>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-layout>
            <v-flex md12>
              <v-list>
                <v-list-item>
                  <span class="tituloSeccion gris labelConfig" style="width:100%">
                    <b>{{formatearFechaAlta(incidencia)}} - {{'Pendiente'}}</b> - {{'Alta de la solicitud'}}
                  </span>
                </v-list-item>
              </v-list>
              <v-list v-for="(item, i) in logIncidences" :key="i+'-data'">
                <v-list-item>
                  <span class="tituloSeccion gris labelConfig" style="width:100%">
                    <b>{{ formatearFecha(item.fecha) }} - {{item.horaAlta}} - {{ item.descripcion }}</b> - {{ item.observaciones }} 
                    <span v-if="procesaUsuarioLog(item.dataUser)" class="dataUserlog" > - ( {{procesaUsuarioLog(item.dataUser)}} )</span>
                  </span>
                </v-list-item>
              </v-list>
            </v-flex>
          </v-layout>
          <v-layout v-if="!rolCliente" mt-3>
            <h2 class="primary--text text-uppercase text-center">
              {{localization.notas.title}}
            </h2>
          </v-layout>
          <v-divider v-if="!rolCliente" class="divider_subtitle"></v-divider>
          <v-layout v-if="!rolCliente" wrap>
            <v-flex mt-4 mr-2 ml-2 xs12 sm12 md3 aling-center
              v-for="(item, i) in annotations" :key="i+'-data'">
              <v-card>
                <v-card-subtitle class="pb-0">{{ titleNota(item) }}</v-card-subtitle>
                <v-card-text class="text--primary">
                  <div>{{ item.annotation }}</div>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="orange" @click="edit(item)" text>
                    {{localization.notas.editButton}}
                  </v-btn>
                  <v-btn color="red" text @click="openDeleteDialog(item.id, item.notaVisita)">
                    {{localization.notas.deleteButton}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <ConfirmDialog :dialogFlag="dialog" @cancel="dialog = false"
              :text="deleteTextDialog" @close="deleteItem()" />
            <EditAnnotation v-model="dialogEdit" id="dialogEdit" :nota="notaToEdit"
              :incidence="this.incidencia.id" />
            <AddAnnotation v-model="dialogAdd" id="dialogAdd" :incidence="this.incidencia.id" />
            <FullSizeImg :imgId="imgId" :imgUrl="imgUrl" v-model="openFullSize" id="openFullSize" />
          </v-layout>
          <v-layout v-if="!rolCliente" mt-4>
            <v-btn color="primary" @click="dialogAdd = true">
              {{localization.addButton}}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import EditAnnotation from './editAnnotation'
import AddAnnotation from './addAnnotation'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'
import FullSizeImg from '../../custom/fullSizeImgPopUp'

export default {
  mixins: [rulesMixin],
  props: {
    incidencia: {}
  },
  components: {
    ConfirmDialog,
    EditAnnotation,
    AddAnnotation,
    FullSizeImg
  },
  data () {
    return {
      valid: true,
      checkElementFacturado: null,
      dialog: false,
      dialogEdit: false,
      notaToEdit: {},
      notaId: '',
      dialogAdd: false,
      valuesCierreFirma: {},
      openFullSize: false,
      imgUrl: '',
      imgId: null,
      deleteTextDialog: ''
      // Boolean(incidencia.facturado)
    }
  },
  mounted () {
    this.valuesCierreFirma.objetoId = this.incidencia.id
    this.valuesCierreFirma.tipoObjetoId = '2'
    this.valuesCierreFirma.carpetaId = '4' // 252876 - La carpetaID correcta es la 4 (incidencias - firma cierre)

    this.getLastLogIncidence(this.incidencia.id)
    this.getLogIncidence(this.incidencia.id)
    this.getAnnotations(this.incidencia.id)
    this.getSmallPicturesCierreFirma(this.valuesCierreFirma)
  },
  methods: {
    ...mapActions({
      getLastLogIncidence: 'incidencias/getLastLogIncidence',
      getLogIncidence: 'incidencias/getLogIncidence',
      getAnnotations: 'incidencias/getAnnotations',
      deleteAnnotation: 'incidencias/deleteAnnotation',
      getSmallPicturesCierreFirma: 'incidencias/getSmallPicturesCierreFirma',
    }),
    updateCambiado (val) {
      this.$emit('cambiado', val)
    },
    titleNota (nota) {
      var title = this.formatearFecha(nota.date)
      if (nota.actor !== null) {
        if (this.notNullNorEmpty(nota.actor.nombre) && this.notNullNorEmpty(nota.actor.apellidos) && this.notNullNorEmpty(nota.actor.email)) {
          title = title + ' - ' + nota.actor.apellidos + ', ' + nota.actor.nombre + ' (' + nota.actor.email + ')'
        } else if (this.notNullNorEmpty(nota.actor.nombre) && this.notNullNorEmpty(nota.actor.apellidos)) {
          title = title + ' - ' + nota.actor.apellidos + ', ' + nota.actor.nombre
        } else if (this.notNullNorEmpty(nota.actor.nombre) && this.notNullNorEmpty(nota.actor.email)) {
          title = title + ' - ' + nota.actor.nombre + ' (' + nota.actor.email + ')'
        } else if (this.notNullNorEmpty(nota.actor.apellidos) && this.notNullNorEmpty(nota.actor.email)) {
          title = title + ' - ' + nota.actor.apellidos + ' (' + nota.actor.email + ')'
        } else if (this.notNullNorEmpty(nota.actor.nombre)) {
          title = title + ' - ' + nota.actor.nombre
        } else if (this.notNullNorEmpty(nota.actor.apellidos)) {
          title = title + ' - ' + nota.actor.apellidos
        } else if (this.notNullNorEmpty(nota.actor.email)) {
          title = title + ' - ' + nota.actor.email
        } else {
          title = title + ' - ' + nota.actorId
        }
      } else {
        title = title + ' - ' + nota.actorId
      }
      return title
    },
    notNullNorEmpty (value) {
      return value != null && value != ''
    },
    expandImg (data, id) {
      this.imgUrl = data
      this.imgId = id
      console.log(this.imgUrl)
      this.openFullSize = true
    },
    recargar () {
      this.getLastLogIncidence(this.incidencia.id)
      this.getLogIncidence(this.incidencia.id)
      this.getAnnotations(this.incidencia.id)
    },
    openDeleteDialog (itemId, notaVisita) {
      this.notaId = itemId

      if ( notaVisita == 1 ) {
        this.deleteTextDialog = this.$t('addAnnotation.avisoEliminarNotaVisita')
      }
      else {
        this.deleteTextDialog = this.$t('verIncidencia.documentacion.deleteMessage')
      }

      this.dialog = true
    },
    deleteItem () {
      this.deleteAnnotation({
        id: this.notaId,
        incidenceId: this.incidencia.id
      })
        .then(() => {
          this.getAnnotations(this.incidencia.id)
        })
        .catch(e => {
          return e
        })
      this.dialog = false
    },
    edit (item) {
            this.notaToEdit = {}
      this.notaToEdit = {...item}
      this.dialogEdit = true
    },
    formatearFecha (fecha) {
      return (fecha) ? moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    formatearFechaAlta (incidencia) {
      // casos
      let fecha = null

      if(incidencia.fechaAviso === null) {
        //en lugar de fecha de alta se usa la fecha de la visita (bbdd -> visita.fecha)
        if(incidencia.fecha) {
          fecha = moment(incidencia.fecha, 'DD-MM-YYYY').format('DD/MM/YYYY')
        } else {
          fecha = moment(incidencia.fechaAlta, 'YYYY-MM-DD').format('DD/MM/YYYY')
        }
      } else {
        // fecha de alta y fecha de aviso son iguales -> se usa fecha de alta
        let momentFechaAviso = moment(incidencia.fechaAviso, 'YYYY-MM-DD').format('DD/MM/YYYY')

        //en lugar de fecha de alta se usa la fecha de la visita (bbdd -> visita.fecha)
        
        // 23/10/2020 - ARN - nueva modificacion si no tiene fechaAviso ni visita.fecha
        let momentFechaAlta
        if(incidencia.fecha) {
          momentFechaAlta = moment(incidencia.fecha, 'DD-MM-YYYY').format('DD/MM/YYYY')
        } else {
          momentFechaAlta = moment(incidencia.fechaAlta, 'YYYY-MM-DD').format('DD/MM/YYYY')
        }
        
        var arrFechaAviso = momentFechaAviso.split("/");
        var dateFechaAviso = new Date(arrFechaAviso[2], arrFechaAviso[1] - 1, arrFechaAviso[0]);
        var arrFechaAlta = momentFechaAlta.split("/");
        var dateFechaAlta = new Date(arrFechaAlta[2], arrFechaAlta[1] - 1, arrFechaAlta[0]);
        
        fecha = ((dateFechaAviso - dateFechaAlta) !== 0) ? moment(incidencia.fechaAviso, 'YYYY-MM-DD').format('DD/MM/YYYY') : moment(incidencia.fecha, 'DD-MM-YYYY').format('DD/MM/YYYY')
      }
      
      return fecha
    },
    validar () {
      return this.$emit('validar', this.$refs.formCostes.validate())
    },
    procesaUsuarioLog(dataUser) {
        let textouser = null
        if(dataUser) {
            if(dataUser.email) {
              textouser = dataUser.email
            }
            if(dataUser.roles) {
              if(textouser) {
                textouser = textouser + ' - ' + dataUser.roles
              } else {
                textouser = dataUser.roles
              }
            }
        }
      return textouser
    }
  },
  computed: {
    ...mapGetters({
      getCierrePicturesFirma: 'incidencias/getCierrePicturesFirma'
    }),
    rolCliente () {
      return this.$store.state.login.rolCliente
    },
    rolProveedor () {
      return this.$store.state.login.rolProveedor
    },
    localization () {
      return this.$t('verIncidencia.evolucion')
    },
    lastLogIncidence () {
      if (this.$store.state.incidencias.lastLogIncidence && this.$store.state.incidencias.lastLogIncidence.codigo === '50') {
        return this.$store.state.incidencias.lastLogIncidence
      }
      return []
    },
    logIncidences () {
      if (this.$store.state.incidencias.historyStatus) {
        return this.$store.state.incidencias.historyStatus
      }
      return []
    },
    annotations () {
      if (this.$store.state.incidencias.annotations) {
        return this.$store.state.incidencias.annotations
      }
      return []
    },
    computadaFechaCierre () {
      return (this.lastLogIncidence.fecha) ? moment(this.lastLogIncidence.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    vistoBueno () {
      return this.lastLogIncidence.vb === '1'
    },
    nombreClienteCierre () {
      return this.incidencia.nombreClienteCierre
    },
    nifClienteCierre () {
      return this.incidencia.nifClienteCierre
    },
    textoConformidad () {
      return this.incidencia.textoCierreIncidencia != null ? this.incidencia.textoCierreIncidencia : ''
    }
  },
  watch: {
    'incidencia.costeEstimado': function () {
      this.updateCambiado(true)
    },
    'incidencia.costeAprobado': function () {
      this.updateCambiado(true)
    },
    'incidencia.costeRechazado': function () {
      this.updateCambiado(true)
    },
    'incidencia.costeReal': function () {
      this.updateCambiado(true)
    }
  }
}
</script>

<style scoped>
.dataUserlog {
  font-size: 0.8em;
  color: #9e9e9e;
}
</style>
